var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"overflow"},_vm._l((_vm.products),function(p){return _c('ProductCard',_vm._b({key:p.id,attrs:{"canAddToCart":true}},'ProductCard',p,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }